<script setup lang="ts">
import CustomButton from '@/components/CustomButton.vue';
import Dialog from '@/components/dialogs/Dialog.vue';

const emit = defineEmits(['continue', 'cancel']);

const isDialogOpen = defineModel<boolean>();

function closeDialog() {
    isDialogOpen.value = false;
}

function emitAndContinue() {
    emit('continue');
    closeDialog();
}

function emitAndCancel() {
    emit('cancel');
    closeDialog();
}

const props = defineProps<{
    text: string;
    title?: string;
}>();
</script>

<template>
    <Dialog v-model="isDialogOpen" :title="props.title ?? 'Actie bevestigen'" :max-width="500" :show-close-button="false">
        <div>{{ props.text }}</div>
        <template #actions>
            <CustomButton @click="emitAndContinue" text="Bevestigen" />
            <CustomButton color="red" @click="emitAndCancel" text="Annuleren" />
        </template>
    </Dialog>
</template>

<style scoped></style>
